/**
 * Counter Component — animated stat numbers
 * Usage in Alpine: x-data="counter(130, '+')"
 */
export default function registerCounter(Alpine) {
    Alpine.data('counter', (target, suffix = '') => ({
        current: 0,
        target,
        suffix,
        started: false,
        display: '0',

        start() {
            if (this.started) return;
            this.started = true;

            const duration = 2000; // ms
            const steps = 60;
            const increment = this.target / steps;
            const stepTime = duration / steps;
            let current = 0;

            const timer = setInterval(() => {
                current += increment;
                if (current >= this.target) {
                    current = this.target;
                    clearInterval(timer);
                }
                this.current = Math.round(current);
                this.display = this.current.toLocaleString() + this.suffix;
            }, stepTime);
        },
    }));
}
